<template>
  <div class="task" v-if="!isLoginFree">
    <div class="pos">
      <new-head zai="false" title="群英荟" :isBack="false">
        <template slot="right">
          <span style="font-size: 14px" @click="screenShow = true">筛选</span>
        </template>
      </new-head>
      <my-tabs :isShowNum="false" v-model="navIndex" :navList="navList"></my-tabs>
    </div>
    <div class="kong"></div>
    <task-list-com
      v-if="navIndex == 0"
      key="1"
      :type="1"
      :searchVal="searchVal"
      :tag="tag"
      ref="taskListCom"
      @setTotal="setTotal($event)"
    ></task-list-com>
    <task-list-com
      v-if="navIndex == 1"
      key="2"
      :type="2"
      :searchVal="searchVal"
      :tag="tag"
      ref="taskListCom"
      @setTotal="setTotal($event)"
    ></task-list-com>
    <task-list-com
      v-if="navIndex == 2"
      key="3"
      :type="3"
      :searchVal="searchVal"
      :tag="tag"
      ref="taskListCom"
      @setTotal="setTotal($event)"
    ></task-list-com>

    <!-- 筛选框 -->
    <van-popup v-model="screenShow" position="top" :style="{ height: '366px' }">
      <div class="screenContent">
        <new-head :isBack="false" title="群英荟">
          <template slot="right">
            <span style="font-size: 14px" @click="screenShow = false">筛选</span>
          </template>
        </new-head>
        <div class="screenBody">
          <div class="search">
            <van-icon name="search" />
            <input type="text" v-model="searchVal" placeholder="搜索任务名称" />
          </div>
          <h3>请选择任务标签</h3>
          <div class="labels">
            <div
              class="label fontCenter"
              v-for="(item, i) in tags"
              :key="i"
              :class="{ labelActive: tag == item }"
              @click="tagTap(item)"
            >
              {{ item }}
            </div>
          </div>
        </div>
        <van-button type="info" class="screenConfirm" @click="screenConfirm"
          >确认</van-button
        >
      </div>
    </van-popup>
  </div>
</template>

<script>
import Cookie from "js-cookie";
import taskListCom from "./components/taskListCom.vue";
import { getTaskTagApi } from "@/api/api/task.js";
export default {
  components: {
    taskListCom,
  },
  data() {
    return {
      tags: [],
      tag: "",
      navList: [
        {
          text: "已发布",
          num: null,
        },
        {
          text: "已领取",
          num: null,
        },
        {
          text: "已关闭",
          num: null,
        },
      ],
      navIndex: 0,
      screenShow: false,
      searchVal: "",
      receiveDialogShow: false,
      isLoginFree: true, //是否为免登录进入该页面,
      userInfo:null
    };
  },
  created() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"))
    console.log('userInfo', this.userInfo);
    let token = this.$route.query.token;
    if (token) {
      console.log(token);
      Cookie.set("token", token, { expires: 0.05 });
      this.isLoginFree = false;
      this.getTaskTag();
    } else {
      this.isLoginFree = false;
      this.getTaskTag();
    }
  },
  methods: {
    async getTaskTag() {
      let res = await getTaskTagApi();
      this.tags = res.data.data;
    },
    tagTap(e) {
      if (this.tag == e) {
        return (this.tag = "");
      }
      this.tag = e;
    },
    screenConfirm() {
      this.$refs.taskListCom.onRefresh();
      this.screenShow = false;
    },
    setTotal(e) {
      this.navList[0].num = e.unclaimed_num;
      this.navList[1].num = e.receive_num;
      this.navList[2].num = e.close_num;
    },
  },
};
</script>

<style lang="scss" scoped>
.task {
  min-height: 100%;
  padding-bottom: 60px;
  .kong {
    margin-top: 107px;
  }
  .pos {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
  }
  .screenContent {
    height: 100%;
    display: flex;
    flex-direction: column;
    .screenBody {
      flex: 1;
      padding: 15px;
      .search {
        height: 40px;
        background: #f6f6f6;
        border-radius: 6px;
        display: flex;
        align-items: center;
        font-size: 13px;
        i {
          font-weight: 700;
          font-size: 16px;
          margin: 0 8px;
        }
        input {
          height: 100%;
          flex: 1;
          background: none;
        }
      }
      h3 {
        margin: 12px 0;
        font-size: 13px;
      }
      .labels {
        display: flex;
        flex-wrap: wrap;
        .label {
          width: 55px;
          height: 25px;
          border: 1px solid #0286ff;
          border-radius: 4px;
          margin-right: 10px;
          margin-bottom: 5px;
          font-size: 13px;
        }
        .labelActive {
          background: #0286ff;
          color: #fff;
        }
      }
    }
    .screenConfirm {
      width: 100%;
      height: 47px;
      font-size: 16px;
    }
  }
}
</style>
